import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { OWNER_PW_KEY } from "../components/HiddenColsLock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/settings/bonus`;
const EMPTY = { left: {}, right: {} };

// Owner bonus points for this race (left = leg 1, right = leg 2), shared by all users.
export const useOwnerBonus = ({ slug, race, date }) => {
  const [bonus, setBonus] = useState(EMPTY);
  const r = parseInt(race, 10);
  const ready = !!slug && r > 0 && !!date;

  const load = useCallback(async () => {
    if (!ready) return;
    try {
      const resp = await fetch(`${API}?track=${encodeURIComponent(slug)}&date=${date}&race=${r}`);
      if (resp.ok) setBonus(await resp.json());
    } catch {
      /* keep last known */
    }
  }, [ready, slug, date, r]);

  useEffect(() => {
    setBonus(EMPTY);
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, [load]);

  const save = useCallback(
    async (leg, post, points) => {
      if (!ready) return;
      const resp = await fetch(API, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-Owner-Password": localStorage.getItem(OWNER_PW_KEY) || "",
        },
        body: JSON.stringify({ track: slug, date, race: leg === "left" ? r : r + 1, post, points }),
      });
      if (!resp.ok) {
        toast.error(resp.status === 401 ? "Owner password needed — unlock again." : "Could not save points.");
        return;
      }
      await load();
    },
    [ready, slug, date, r, load]
  );

  return [bonus, save];
};

export const withBonus = (rows, map, key) =>
  rows.map((row) => {
    const b = map[String(row[key])];
    if (b) return row.BONUS === b ? row : { ...row, BONUS: b };
    return row.BONUS ? { ...row, BONUS: undefined } : row;
  });
